import React from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { BsFilter } from '@react-icons/all-files/bs/BsFilter';
import { BsFilterLeft } from '@react-icons/all-files/bs/BsFilterLeft';
import { BsFilterRight } from '@react-icons/all-files/bs/BsFilterRight';
import { BsType } from '@react-icons/all-files/bs/BsType';
import { FiChevronRight } from '@react-icons/all-files/fi/FiChevronRight';
import { ButtonGroupField, NumberInputField, Option, SelectField, TextareaField } from '@bucketplace/commerce-admin-ui';

import { FormContent } from '../../components/FormContent';
import { ColorPickerField } from '../../components/Input/ColorPickerField';
import { InspectorFormProvider } from '../../components/InspectorFormProvider';
import { COLORS } from '../../styles';
import { DocumentInspectorProps } from '../../types';
import { TextProps } from './Text';

const WEIGHT_OPTIONS: Option<string | number>[] = [
  { text: 'Regular', value: 'lighter' },
  { text: 'Medium', value: 500 },
  { text: 'Bold', value: 600 },
];

const ALIGN_OPTIONS = [
  {
    text: <BsFilterLeft />,
    value: 'left',
  },
  {
    text: <BsFilter />,
    value: 'center',
  },
  {
    text: <BsFilterRight />,
    value: 'right',
  },
];

export function TextInspector({
  value,
  onChange,
}: DocumentInspectorProps<TextProps>) {
  return (
    <InspectorFormProvider value={value} onChange={onChange}>
      <FormContent
        header="내용"
        required
        direction="VERTICAL"
      >
        <TextareaField
          name="value"
          width="100%"
          placeholder="내용을 입력해주세요."
          rules={{
            required: true,
            validate: (value) => value.trim() !== '',
          }}
        />
        <ExternalLink
          href="https://ko.wikipedia.org/wiki/%EB%A7%88%ED%81%AC%EB%8B%A4%EC%9A%B4"
          target="_blank"
        >
          마크다운 문법
          <FiChevronRight />
        </ExternalLink>
      </FormContent>
      <FormContent
        header="크기"
      >
        <NumberInputField
          name="size"
          width="100%"
          maxCount={2}
          direction="HORIZONTAL"
          customCss={css`
            > div {
              width: 100%;
            }
          `}
          label={<BsType />}
        />
      </FormContent>
      <FormContent header="굵기">
        <SelectField
          name="weight"
          width="100%"
          options={WEIGHT_OPTIONS}
        />
      </FormContent>
      <FormContent header="정렬">
        <ButtonGroupField
          name="align"
          width="100%"
          options={ALIGN_OPTIONS}
        />
      </FormContent>
      <FormContent header="글자색">
        <ColorPickerField
          name="color"
          width="100%"
        />
      </FormContent>
    </InspectorFormProvider>
  );
}

const ExternalLink = styled.a`
  display: block;
  font-size: 10px;
  color: ${COLORS.blue40};
  text-align: right;
  text-decoration: none;
  svg {
    vertical-align: middle;
  }
`;
